/**
 * Created by wjjn3481 on 2017/4/24.
 */
import Vue from 'vue'

const state = {}

const mutations = {
    USER_SIGN_IN (state, user) {
        Object.assign(state, user)
        window.waterMarkContext.onLoad(() => {
            // 添加水印
            window.WaterMark.mark({text: [user.email.split('@')[0] || 'undefined', user.encryptData.ciphertext || 'undefined', user.name || 'undefined'].join('_')})
        })
    },

    USER_SIGN_OUT (state) {
        Object.keys(state).forEach(key => Vue.delete(state, key))
        // 去掉水印
        window.WaterMark instanceof Function && window.WaterMark.clear()
    }
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js